export class SourceCitationBase {
    id: number;
    type : number;
    comment  : string;
    volume  : string;
    quality  : number;
    formattedText  : string;
    url  : string;
}